/**
 * Revelado al entrar en viewport.
 *
 * Deliberadamente mínimo: opacidad y 12px de desplazamiento. En una tienda de
 * alta costura el movimiento debe notarse apenas — cualquier cosa más marcada
 * compite con la fotografía, que es el producto.
 *
 * El CSS ya respeta prefers-reduced-motion; aquí sólo se añade la clase.
 */

/* Dentro del editor de temas no se anima nada.

   El iframe del editor no siempre dispara IntersectionObserver al reinyectar
   una sección, así que los elementos se quedaban en opacity: 0 y parecía que la
   sección no existía — mientras que publicada se veía bien. Una animación no
   puede esconder contenido mientras alguien edita. */
if (window.Shopify && window.Shopify.designMode) {
  document.querySelectorAll('.sc-reveal').forEach((el) => el.classList.add('is-visible'));
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.sc-reveal').forEach((el) => el.classList.add('is-visible'));
  });
} else {
  /* Marca el documento antes de nada. El CSS sólo oculta elementos si esta clase
     está presente, así que si este script no llega a ejecutarse la página se ve
     entera en lugar de quedarse en blanco. */
  document.documentElement.classList.add('sc-js');
}

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target); // una sola vez: no reaparece al volver
    }
  },
  { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
);

function observeAll(root = document) {
  root.querySelectorAll('.sc-reveal:not(.is-visible)').forEach((el) => observer.observe(el));
}

observeAll();

// El editor de temas inyecta secciones sin recargar; hay que reobservar.
document.addEventListener('shopify:section:load', (event) => observeAll(event.target));
